import React from 'react'
import cn, { Argument as ClassName } from 'classnames'

import { PageHeader } from '../../../lib/page-header'

const MENU_LINKS = [
    { href: '/dashboard', labelCode: 'btnHome' },
    { href: '/user-profile', labelCode: 'lblProfile' },
    { href: '/statistics', labelCode: 'lblStatistics' },
    { href: '/remotecontrol', labelCode: 'btnRemoteControl' },
    { href: '/support', labelCode: 'lblSupport' },
]

export type UserappPageHeaderProps = {
    className?: ClassName
    style?: React.CSSProperties
}

export function UserAppPageHeader({ className, style }: UserappPageHeaderProps): React.ReactElement {
    return <PageHeader className={cn(className)} style={style} links={MENU_LINKS} />
}
